import { api } from "../../../api";

const root = process.env.REACT_APP_BACKEND_FINANCE_URL;
const route = api(root);
const token = JSON.parse(localStorage.getItem("user"))?.userToken;

const AssetNBVService = {
  async getAssets({ search, startDate, endDate, pageSize, pageNumber }) {
    try {
      let { data } = await route.get(
        `/AssetDepreciationNBV/AsssetDepreciationNBVDashboardQuery?Search=${search}&StartDate=${startDate}&EndDate=${endDate}&PageSize=${pageSize}&PageNumber=${pageNumber}`,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );
      // console.log({ getAssets: data });

      return data;
    } catch (e) {
      console.log("error", e);
    }
  },
};

export default AssetNBVService;
